import React  from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import '../src/components/css/style.css';
import '../src/components/css/responsive.css';
// components
import LoginSignup from "./components/LoginSignup";
import Dashboard from "./components/Dashboard";
import Consult from "./components/Consult";
import Health from "./components/Health";
import History from "./components/History";
import Notification from "./components/Notification";
import Reminder from "./components/Reminder";
import Preventive from "./components/Preventive";

function App() {
  return (
    <div className="App_outer">
      <Router>
        <Routes>
          <Route exact path="/" element={<LoginSignup title="LoginSignup" />} />
          <Route exact path="/Dashboard" element={<Dashboard title="Dashboard" />} />
          <Route exact path="/Consult" element={<Consult title="Consult"/>} />
          <Route exact path="/Health" element={<Health title="Health"/>} />
          <Route exact path="/History" element={<History title="History"/>} />
          <Route exact path="/Notification" element={<Notification title="Notification"/>} />
          <Route exact path="/Reminder" element={<Reminder title="Reminder"/>} />
          <Route exact path="/Preventive" element={<Preventive title="Preventive" />} />
        </Routes>
      </Router>
    </div>
  );
}
export default App;